import React, { useState, useEffect } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import _ from "lodash"
import Title from "../general/title"
import FullTable from "components/FullTable"
import helpers from "helpers/helpers"
import Switch from "react-switch"
import { HorizontalBar } from "react-chartjs-2"
import colorArray from "helpers/colorArray"
import InfoDetail from "components/InfoDetail"
import moment from "moment"
import Chart from "react-apexcharts"
import LotInventoryReplacementTable from "widgets/lotInventoryReplacementTable"

function Vacants(props) {
	const [developer, setDeveloper] = useState(true)
	const columns = [
		{
			Header: "Address",
			accessor: "address",
			filterMethod: (f, r) => helpers.tableText(f, r, "address"),
		},
		{
			Header: "Builder",
			accessor: "builder",
			filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
		},
		{
			Header: "Neighborhood",
			accessor: "neighborhood",
			filterMethod: (f, r) => helpers.tableText(f, r, "neighborhood"),
		},
		{
			Header: "Lot",
			accessor: "lot",
			filterMethod: (f, r) => helpers.tableText(f, r, "lot"),
		},
		{
			Header: "Block",
			accessor: "block",
			filterMethod: (f, r) => helpers.tableText(f, r, "block"),
		},
		{
			Header: "Section",
			accessor: "section",
			filterMethod: (f, r) => helpers.tableText(f, r, "section"),
		},
		{
			Header: "Lot Type",
			accessor: "lot_type",
			filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
		},
		{
			Header: "Takedown Date",
			accessor: "takedown_date",
			filterMethod: (f, r) => helpers.dateFilter(f, r, "takedown_date"),
			Cell: (v) => helpers.tableDate(v),
		},
	]
	const history = [
		{
			Header: "Month",
			accessor: "month",
			filterMethod: (f, r) => helpers.tableText(f, r, "month"),
		},
		{
			Header: "Year",
			accessor: "year",
			filterMethod: (f, r) => helpers.tableText(f, r, "year"),
		},
		{
			Header: "Vacants",
			accessor: "vacants",
			filterMethod: (f, r) => helpers.tableText(f, r, "vacants"),
		},
	]

	const buildTable = () => {
		let ret = []
		_.forEach(props.payload.exec.lots, (v) => {
			if (developer && !v.takedown_date) return
			if (v.start_date || v.complete_date || v.sale_id || v.model == 1 || v.buyer_id) return
			let pulled = helpers.trimObject(v, ["address", "lot", "block", "takedown_date"])
			let neigh = _.find(props.payload.public.neighborhoods, { id: v.neighborhood })
			let type = _.find(props.payload.public.lot_types, { id: v.lot_type })
			let builder = _.find(props.payload.public.builders, { id: v.builder })
			let section = _.find(props.payload.public.sections, { id: v.section_id })
			if (!v.takedown_date) {
				builder = { name: "Developer" }
			}
			let f = {
				//neighborhood: neigh ? neigh.name : '',
				...pulled,
				neighborhood: neigh ? neigh.name : "",
				address: v.address,
				builder: builder ? builder.name : "",
				lot_type: type ? type.name : "",
				section: section ? section.name : "",
			}
			ret.push(f)
		})

		return ret
	}
	
	const buildVDLHistory = () => {
		let ret = []
		let oldestMonth = 9999999999999
		_.forEach(props.payload.exec.lots, (v) => {
			let section = _.find(props.payload.public.sections, { id: v.section_id })
			if (section && section.completion && section.completion < oldestMonth) {
				oldestMonth = section.completion
			}
		})
		let oldestYear = moment.unix(oldestMonth).year()
		let years = {}
		let months = [
			"January",
			"February",
			"March",
			"April",
			"May",
			"June",
			"July",
			"August",
			"September",
			"October",
			"November",
			"December",
		]
		for (let i = moment().year(); i > oldestYear; i--) {
			years[i] = {}
			for (let m of months) {
				if (i == moment().year() && moment().month() < months.indexOf(m)) continue
				years[i][m] = 0
			}
		}

		_.forEach(years, (r1, year) => {
			_.forEach(r1, (r2, month) => {
				let startOfMonth = moment().year(year).month(month).startOf("month").unix()
				let endOfMonth = moment().year(year).month(month).endOf("month").unix()

				let lots = _.filter(props.payload.exec.lots, (v) => {
					if (!props.activeProperties.includes(v.property)) return false
					let section = _.find(props.payload.public.sections, { id: v.section_id })
					if (!section) return false
					let completion = section.completion
					if (completion && completion <= startOfMonth && (v.start_date > endOfMonth || !v.start_date)) {
						if (v.sale_date && v.sale_date < endOfMonth) return false
						return true
					}
				})
				years[year][month] += lots.length
			})
		})
		//console.log(years)
		_.forEach(years, (r1, year) => {
			_.forEach(r1, (r2, month) => {
				ret.push({
					year: year,
					month: month,
					vacants: r2,
				})
			})
		})

		return ret
	}

	const statusBars = () => {
		let statuses = {
			"Builder Owned": 0,
			"Developer Owned - Delivered": 0,
			"Developer Owned - Pending": 0,
			"Developer Owned Unassigned to Builder": 0,
		}
		let count = 0
		_.forEach(props.payload.exec.lots, (v) => {
			if (developer && !v.takedown_date) return
			if (v.start_date || v.complete_date || v.closing_date || v.sale_id || v.model == 1 || v.buyer_id) {
				return
			}
			if (v.takedown_date) {
				statuses["Builder Owned"]++
			} else if (v.builder && v.substantially_complete) {
				statuses["Developer Owned - Delivered"]++
			} else if (v.builder && !v.substantially_complete) {
				statuses["Developer Owned - Pending"]++
			} else if (!v.builder) {
				statuses["Developer Owned Unassigned to Builder"]++
			}
			count++
		})
		//
		const data = {
			labels: _.keys(statuses),
			datasets: [
				{
					data: _.values(statuses),
					backgroundColor: colorArray,
				},
			],
		}

		const opts = {
			legend: {
				display: false,
				position: "bottom",
			},
		}

		return (
			<>
				<h3>
					Vacant Lot Inventory
					<InfoDetail text="Delivered: Sections which are substantially complete. Pending: Sections which are not yet substantially complete, but are in lot purchase contracts to builders and are pre-sale opportunities." />
				</h3>
				<p style={{ margin: 0, fontSize: "14px" }}>Total Lots: {count.toLocaleString()}</p>
				<HorizontalBar data={data} options={opts} />
			</>
		)
	}

	const Flip = () => {
		return (
			<div className="switch content pl-0" style={{ marginBottom: 15 }} onClick={(e) => e.stopPropagation()}>
				<Switch
					onChange={() => {
						setDeveloper(!developer)
					}}
					checked={developer}
					checkedIcon={false}
					uncheckedIcon={false}
					key={"switch"}
					id={"switch"}
				/>
				<p>Showing {developer ? "Taken Down" : "All"} Lots</p>
			</div>
		)
	}

	const lotTypeBars = () => {
		let store = {}
		let count = 0
		_.forEach(props.payload.exec.lots, (v) => {
			if (developer && !v.takedown_date) return
			if (v.start_date || v.complete_date || v.closing_date || v.sale_id || v.model == 1 || v.buyer_id) {
				return
			}
			let lt = _.find(props.payload.public.lot_types, { id: v.lot_type })
			if (!_.has(store, lt.name)) store[`${lt.name}`] = 0
			store[lt.name]++
			count++
		})

		let options = {
			chart: {
				type: "bar",
				//height: 350,
				toolbar: {
					show: true,
					tools: {
						download: false,
					},
				},
			},
			plotOptions: {
				bar: {
					horizontal: true,
					distributed: true,
				},
			},
			stroke: {
				width: 1,
				colors: ["#fff"],
			},
			xaxis: {
				categories: _.keys(store),
			},
			colors: colorArray,
			fill: {
				opacity: 1,
			},
			dataLabels: {
				enabled: true,
			},
		}
		let d = []
		_.forEach(store, (v, k) => {
			d.push(v)
		})
		let series = [
			{
				name: "Lots",
				data: d,
			},
		]
		return (
			<>
				<h3>Vacant Lot Inventory - Lot Type</h3>
				<p style={{ margin: 0, fontSize: "14px" }}>Total Lots: {count.toLocaleString()}</p>
				<Chart options={options} series={series} type="bar" />
			</>
		)
	}

	if (!props.payloadStatus) {
		return ""
	} else {
		return (
			<div className="sales">
				<div className="imageGroup">
					<Title title="Vacant Lot Inventory" showDate={false} />
				</div>
				<div className="imageGroup">
					<div className="content">
						<Flip />
						<FullTable
							data={buildTable()}
							columns={columns}
							name="vacant__detailed"
							title="Vacant Lot Inventory"
							classNames="small"
							pageSize={20}
						/>
					</div>
				</div>
				<div className="imageGroup">
					<div className="content">
						<Flip />
						<div className="statBox__row statBox__row--double">
							<div className="statBox__box">{statusBars()}</div>
							<div className="statBox__box">{lotTypeBars()}</div>
						</div>
					</div>
				</div>
				<div className="imageGroup">
					<div className="content">
						<LotInventoryReplacementTable {...props} />
						<h2>
							VDL History By Month
							<InfoDetail text="Lots whose start date is after the end of the month, while being substantially completed at the section level (delivered) at the beginning of the month." />
						</h2>
						<p className="text-xs mt-2">All VDL lots at the end of each month.</p>
						<FullTable
							data={buildVDLHistory()}
							columns={history}
							name="vacant__history"
							title="Vacant Lot History"
							classNames="small"
							pageSize={20}
						/>
					</div>
				</div>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(Vacants)
